import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { resetPassword } from '../../actions/authentication';
import { ONE_UPPERCASE_ONE_LOWERCASE_REGEX, ONE_NUMBER_REGEX } from '../../config/app_config';
import PasswordResetForm from './PasswordResetForm';

const FORM_ID = 'loginForm';

export class PasswordResetFormContainer extends React.Component {
  static propTypes = {
    invalid: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    passwordResetAction: PropTypes.func.isRequired,
    securityToken: PropTypes.string,
    submitting: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    securityToken: null,
  };

  submitPasswordReset = params => {
    const { passwordResetAction, securityToken } = this.props;
    const credentials = {
      plainTextPassword: String(params.password),
      securityToken,
    };
    passwordResetAction(credentials, '/home');
  };

  render() {
    const { invalid, handleSubmit, securityToken, submitting } = this.props;

    return (
      <PasswordResetForm
        invalid={invalid}
        handleSubmit={handleSubmit}
        passwordResetFunction={this.submitPasswordReset}
        securityToken={securityToken}
        submitting={submitting}
      />
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.password || values.password === '') {
    errors.password = 'Required';
  } else if (values.password.length < 8) {
    errors.password = 'Must Be 8 Characters or More';
  } else if (values.password !== values.confirmPassword) {
    errors.password = 'Passwords must match';
  } else if (!values.password.match(ONE_UPPERCASE_ONE_LOWERCASE_REGEX)) {
    errors.password = 'Must contain at least one uppercase and lowercase letter';
  } else if (!values.password.match(ONE_NUMBER_REGEX)) {
    errors.password = 'Must contain at least one number';
  }
  if (!values.confirmPassword || values.confirmPassword === '') {
    errors.confirmPassword = 'Required';
  }
  return errors;
};

const PasswordResetFormContainerRF = reduxForm({
  form: FORM_ID,
  validate,
})(PasswordResetFormContainer);

export default connect(null, {
  passwordResetAction: resetPassword,
})(PasswordResetFormContainerRF);
